export default __webpack_public_path__ + "static/media/consider-it-completed.28b2379c.svg";